export default __webpack_public_path__ + "static/media/plusIcon.63e40992.svg";